/* eslint-disable */
import React from 'react';
import feather from 'feather-icons';

export default (name, measureArray, styles, parentStyles) => {
  const featherString = feather.icons[name].toSvg({
    class: styles,
    width: measureArray[0],
    height: measureArray[1]
  });
  return <div css={parentStyles} dangerouslySetInnerHTML={{ __html: featherString }} />;
};
